<template v-if="globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker'">
	<!-- header -->
	<header id="header">
		<div class="hInner header_aiorderInput subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="#"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">치과별 보철물 설정</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="popup_dental_select">
		<div class="content aiorder_match">
			<div class="contIn">
				<form ref="form_prosthesis_list" id="form_prosthesis_list"
					:action="`${SERVER_URL}/api/app/matching/prostsubcnt`"
					@submit.prevent="form_prosthesis_list_submit()" method="post" autocomplete="off">
					<div class="aiorder_matchList">
						<div class="sub_tit">치과 선택</div>
						<div class="match_search">
							<input id="search" type="text" class="live-search-box" placeholder="검색어를 입력해주세요">
						</div>

						<ul :class="HZwrapper" class="match_list">
							<li v-for="(item, index) in items" :key="index"
								:class="[HZlines, { select: hos_id === item.memberMatching_Hospital.mb_boss_id }]"
								:data-id="item.memberMatching_Hospital.mb_boss_id" data-show="Y"
								@click="parent_goto_url(`${item.memberMatching_Hospital.mb_boss_id}`)"
								:data-search-term="item.memberMatching_Hospital.mb_nick + item.memberMatching_Hospital.mb_busi_addr + item.memberMatching_Hospital.mb_tel + '&nbsp;/&nbsp;' + item.memberMatching_Hospital.mb_hp">
								<input type="radio" class="match_checkbox" :value="item.memberMatching_Hospital.mb_boss_id"
									:checked="hos_id === item.memberMatching_Hospital.mb_boss_id" style="display: none;">
								<div class="match_img">
									<img v-if="item.memberMatching_Hospital.mb_icon"
										:src="`${SERVER_URL}/images/member/${item.memberMatching_Hospital.mb_icon}`"
										style="max-width:100%;">
									<img v-else src="/img/common/profile_ex.png" style="max-width:100%;">
								</div>
								<div class="match_info">
									<p class="match_tit">{{ item.memberMatching_Hospital.mb_nick }}<span
											v-if="item.cnt < 1" class="newIcon">저장필요</span></p>
									<p class="match_txt">{{ item.memberMatching_Hospital.mb_busi_addr }}</p>
									<p class="match_txt">{{ item.memberMatching_Hospital.mb_tel }}&nbsp;/&nbsp;{{ item.memberMatching_Hospital.mb_hp }}</p>
									<p class="match_name">{{ item.memberMatching_Hospital.mb_name }}</p>
								</div>
							</li>
						</ul>

						<div class="nomatch_list">
							<p class="icon_notice_g"></p>
							<p>검색 결과가 존재하지 않습니다.</p>
						</div>
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import * as step1js from '@/components/utils/setting_step1';

const route = useRoute();
const router = useRouter();

if(globaljs.acc_type === 'hospital' || globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

const today = moment().format('YYYY-MM-DD');

const hos_id = ref(route.query.hos_id);

watch(
	() => route.query.hos_id,
	(newVal) => {
		hos_id.value = newVal;
	}
);

const HZwrapper = 'paginationTable';
const HZlines = 'tableItem';

const items = ref([]); // 아이템 리스트

onMounted(async () => {
	if(globaljs.acc_type !== 'hospital' || globaljs.mb_staff !== 'Worker') {
		commonjs.DOMLoaded();
		step1js.DOMLoaded();

		await getModels();
	}
});

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/matching/prostsubcnt`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
	} catch (error) {
console.error('Error getModels:', error);
	}
}

const parent_goto_url = (hos_id) => {
	if(opener){
		opener.select_hos(hos_id);
	}
	self.close();
}
</script>